var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInvitations(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100px",
    height: "100px",
    viewBox: "0 0 700 700",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m574.8 498.96c0.023437-0.19531 0.11328-0.36328 0.11328-0.56641l-0.003906-289.35c0-0.14453-0.074219-0.26953-0.085938-0.41016-0.027343-0.375-0.11719-0.72656-0.22266-1.0977-0.10547-0.36328-0.21094-0.71094-0.38672-1.0469-0.066407-0.12891-0.066407-0.26953-0.14453-0.39063-0.11328-0.18359-0.29688-0.28516-0.42578-0.45312-0.24219-0.30859-0.48047-0.58203-0.78516-0.83594-0.19141-0.15625-0.36328-0.32031-0.57031-0.45312l-62.004-44.426v-29.172c0-3.0898-2.5078-5.6016-5.6016-5.6016h-50.688l-100.5-68.207c-1.9023-1.2891-4.4062-1.2812-6.3008 0.003906l-100.04 68.215h-50.031c-3.0898 0-5.6016 2.5078-5.6016 5.6016v29.043c-0.37109 0.14453-0.75781 0.21875-1.1016 0.44922l-61.078 40.234c-2.2344 1.4727-2.957 4.2383-2.043 6.6406-0.042969 0.12891-0.042969 0.28125-0.085937 0.41016-0.10547 0.37109-0.19531 0.72266-0.22266 1.0977-0.011719 0.14062-0.085937 0.26172-0.085937 0.40234v289.35c0 0.20312 0.09375 0.37109 0.11328 0.56641 0.039063 0.375 0.10547 0.73438 0.22266 1.1016 0.11719 0.37109 0.26953 0.69922 0.45312 1.0312 0.09375 0.16797 0.11719 0.36328 0.23047 0.52734 0.078125 0.11328 0.20703 0.15234 0.29297 0.25391 0.38672 0.47656 0.83984 0.85156 1.3594 1.1758 0.19141 0.125 0.35156 0.28125 0.55469 0.375 0.73828 0.34766 1.5273 0.57031 2.3789 0.57031h436.8c0.15625 0 0.28516-0.078125 0.4375-0.089844 0.39844-0.035156 0.76172-0.11719 1.1484-0.23047 0.33594-0.10156 0.64844-0.20313 0.95312-0.35938 0.3125-0.16406 0.58984-0.36328 0.875-0.58984 0.30078-0.23438 0.57812-0.48047 0.82422-0.77344 0.10156-0.125 0.24609-0.18359 0.33984-0.32031 0.11719-0.16797 0.14062-0.36328 0.24219-0.53906 0.18359-0.33203 0.33594-0.65625 0.45312-1.0195 0.10547-0.36719 0.17578-0.73047 0.21484-1.1133zm-11.09-279.87v268.47l-202.2-143.41zm-222.49 125.05-203.11 143.45v-268.52zm210.52 148.65h-401.59l201.22-142.11zm-360.21-319.86v65.871l-51.684-31.824zm242.54-47.766h-167.03l83.332-56.801zm65.031 11.199v109.52l-147.73 91.359-148.64-91.539v-109.34zm11.199 37.348 48.871 35.016-48.871 30.223z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m480.23 203.31c1.5586-1.457 2.1562-3.668 1.5391-5.7109-0.61719-2.043-2.3359-3.5547-4.4336-3.9102l-19.344-3.2305-8.2773-17.793c-0.90234-1.9336-2.8164-3.1875-4.9492-3.2383-2.0898-0.19141-4.1055 1.1133-5.0898 3.0078l-9.0938 17.438-19.48 2.418c-2.1094 0.25781-3.8984 1.7031-4.5977 3.7109-0.69922 2.0117-0.20312 4.2461 1.2891 5.7695l13.73 14.004-3.7578 19.301c-0.41016 2.0938 0.41016 4.2383 2.1055 5.5273 1.7031 1.293 3.9883 1.5 5.8906 0.55469l17.574-8.7695 17.148 9.5039c0.84375 0.46875 1.7812 0.69922 2.7148 0.69922 1.1211 0 2.2344-0.33594 3.1875-0.99609 1.7539-1.2148 2.6641-3.3164 2.3516-5.4219l-2.8711-19.441zm-15.938-0.44141-8.2266 7.6836c-1.3438 1.2539-1.9805 3.0898-1.7188 4.9102l1.6445 11.137-9.8164-5.4414c-1.6172-0.90234-3.5625-0.93359-5.2188-0.11328l-10.035 5.0117 2.1523-11.02c0.35156-1.8086-0.20703-3.6719-1.5-4.9961l-7.8672-8.0234 11.168-1.3906c1.8242-0.22266 3.4258-1.332 4.2773-2.9688l5.1953-9.9727 4.7266 10.164c0.77734 1.6758 2.3359 2.8555 4.1562 3.1602z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m387.74 203.31c1.5586-1.457 2.1562-3.668 1.5391-5.7109-0.61719-2.043-2.3359-3.5547-4.4336-3.9102l-19.344-3.2305-8.2773-17.793c-0.90234-1.9336-2.8164-3.1875-4.9492-3.2383-2.0938-0.19141-4.1055 1.1133-5.0898 3.0078l-9.0938 17.438-19.48 2.418c-2.1094 0.25781-3.8984 1.6953-4.5977 3.7109-0.69922 2.0117-0.20312 4.2461 1.2891 5.7695l13.73 14.004-3.7617 19.293c-0.41016 2.0938 0.41016 4.2383 2.1055 5.5273 1.7031 1.2891 3.9883 1.5 5.8906 0.55469l17.574-8.7695 17.148 9.5039c0.84375 0.46875 1.7812 0.69922 2.7148 0.69922 1.1211 0 2.2344-0.33594 3.1875-0.99609 1.7461-1.2148 2.6641-3.3164 2.3516-5.4219l-2.8711-19.441zm-15.938-0.44141-8.2266 7.6836c-1.3438 1.2539-1.9805 3.0898-1.7188 4.9102l1.6406 11.137-9.8125-5.4414c-1.6172-0.90234-3.5625-0.93359-5.2188-0.11328l-10.035 5.0117 2.1523-11.02c0.35156-1.8086-0.20703-3.6719-1.5-4.9961l-7.8672-8.0234 11.168-1.3906c1.8242-0.22266 3.4258-1.332 4.2773-2.9688l5.1953-9.9727 4.7266 10.164c0.77734 1.6758 2.3359 2.8555 4.1562 3.1602z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m295.25 203.31c1.5586-1.457 2.1562-3.668 1.5391-5.7109-0.61719-2.043-2.3359-3.5547-4.4336-3.9102l-19.344-3.2305-8.2773-17.793c-0.90234-1.9336-2.8164-3.1875-4.9492-3.2383-2.0938-0.19141-4.1055 1.1133-5.0898 3.0078l-9.0938 17.438-19.48 2.418c-2.1094 0.25781-3.8984 1.6953-4.5977 3.7109-0.69922 2.0117-0.20703 4.2461 1.2891 5.7695l13.73 14.004-3.7578 19.293c-0.41016 2.0938 0.41016 4.2383 2.1055 5.5273 1.7031 1.293 3.9883 1.5 5.8906 0.55469l17.574-8.7695 17.148 9.5039c0.84375 0.46875 1.7812 0.69922 2.7148 0.69922 1.1211 0 2.2344-0.33594 3.1875-0.99609 1.7539-1.2148 2.6641-3.3164 2.3516-5.4219l-2.8711-19.441zm-15.938-0.44141-8.2266 7.6836c-1.3438 1.2539-1.9805 3.0898-1.7188 4.9102l1.6445 11.137-9.8164-5.4414c-1.6172-0.90234-3.5625-0.93359-5.2188-0.11328l-10.035 5.0117 2.1445-11.02c0.35156-1.8086-0.20703-3.6719-1.5-4.9961l-7.8633-8.0234 11.168-1.3906c1.8242-0.22266 3.4258-1.332 4.2773-2.9688l5.1953-9.9727 4.7266 10.164c0.77734 1.6758 2.3359 2.8555 4.1562 3.1602z"
  }), /*#__PURE__*/React.createElement("use", {
    x: 70,
    y: 644,
    xlinkHref: "#s"
  }), /*#__PURE__*/React.createElement("use", {
    x: 90.550781,
    y: 644,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("use", {
    x: 104.359375,
    y: 644,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("use", {
    x: 123.347656,
    y: 644,
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("use", {
    x: 142.242188,
    y: 644,
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("use", {
    x: 155.628906,
    y: 644,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("use", {
    x: 174.617188,
    y: 644,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("use", {
    x: 204.410156,
    y: 644,
    xlinkHref: "#i"
  }), /*#__PURE__*/React.createElement("use", {
    x: 224.453125,
    y: 644,
    xlinkHref: "#h"
  }), /*#__PURE__*/React.createElement("use", {
    x: 252.453125,
    y: 644,
    xlinkHref: "#g"
  }), /*#__PURE__*/React.createElement("use", {
    x: 280.3125,
    y: 644,
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("use", {
    x: 299.210938,
    y: 644,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("use", {
    x: 319.25,
    y: 644,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("use", {
    x: 347.992188,
    y: 644,
    xlinkHref: "#i"
  }), /*#__PURE__*/React.createElement("use", {
    x: 368.03125,
    y: 644,
    xlinkHref: "#h"
  }), /*#__PURE__*/React.createElement("use", {
    x: 396.03125,
    y: 644,
    xlinkHref: "#g"
  }), /*#__PURE__*/React.createElement("use", {
    x: 423.898438,
    y: 644,
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("use", {
    x: 442.789062,
    y: 644,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("use", {
    x: 462.835937,
    y: 644,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("use", {
    x: 70,
    y: 672,
    xlinkHref: "#r"
  }), /*#__PURE__*/React.createElement("use", {
    x: 82.183594,
    y: 672,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("use", {
    x: 95.992188,
    y: 672,
    xlinkHref: "#f"
  }), /*#__PURE__*/React.createElement("use", {
    x: 115.226562,
    y: 672,
    xlinkHref: "#q"
  }), /*#__PURE__*/React.createElement("use", {
    x: 154.152344,
    y: 672,
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("use", {
    x: 167.535156,
    y: 672,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 187.46875,
    y: 672,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("use", {
    x: 216.207031,
    y: 672,
    xlinkHref: "#o"
  }), /*#__PURE__*/React.createElement("use", {
    x: 239.640625,
    y: 672,
    xlinkHref: "#f"
  }), /*#__PURE__*/React.createElement("use", {
    x: 258.878906,
    y: 672,
    xlinkHref: "#n"
  }), /*#__PURE__*/React.createElement("use", {
    x: 278.8125,
    y: 672,
    xlinkHref: "#m"
  }), /*#__PURE__*/React.createElement("use", {
    x: 308.492188,
    y: 672,
    xlinkHref: "#l"
  }), /*#__PURE__*/React.createElement("use", {
    x: 329.015625,
    y: 672,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("use", {
    x: 342.820312,
    y: 672,
    xlinkHref: "#f"
  }), /*#__PURE__*/React.createElement("use", {
    x: 362.058594,
    y: 672,
    xlinkHref: "#k"
  }), /*#__PURE__*/React.createElement("use", {
    x: 371.65625,
    y: 672,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("use", {
    x: 390.648438,
    y: 672,
    xlinkHref: "#j"
  }), /*#__PURE__*/React.createElement("use", {
    x: 407.242188,
    y: 672,
    xlinkHref: "#c"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvitations);
export default __webpack_public_path__ + "static/media/invitations.dc6bb0ca08d5e081acd3bf11dff046ea.svg";
export { ForwardRef as ReactComponent };